import type { ViewsProviderMeta } from '../types';

/**
 * Google Analytics — registrado, ainda sem implementação.
 *
 * `isAvailable: false` deixa o card visível e desabilitado. No backend, a
 * ausência no `ProviderFactory` é o que impede a conexão de verdade: quem
 * tentar por fora da UI recebe 400 limpo, não um erro de runtime.
 */
export const googleAnalyticsProvider: ViewsProviderMeta = {
  id: 'views-google-analytics',
  name: 'Google Analytics',
  description: 'Visitas do seu site medidas pelo GA4',
  icon: 'bar-chart',
  color: '#f9ab00',
  authFields: [],
  isAvailable: false,
};
